// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"bea04d0a","455":"bcb530d0","977":"cfadd6f9"}[chunkId] + ".chunk.js";
};